import { render, staticRenderFns } from "./newDocument.vue?vue&type=template&id=3f8f0f89&scoped=true&"
import script from "./newDocument.vue?vue&type=script&lang=ts&"
export * from "./newDocument.vue?vue&type=script&lang=ts&"
import style0 from "./newDocument.vue?vue&type=style&index=0&id=3f8f0f89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f0f89",
  null
  
)

export default component.exports